import type { JournalCode } from '@/api/client'
import { cn } from '@/lib/cn'
import { useTranslation } from 'react-i18next'

interface Props {
  code: JournalCode
  className?: string
  withLabel?: boolean
}

// JournalCodeBadge renders the two-letter journal code (VT, AC, BQ…)
// with an optional tooltip-style label. Monochrome zinc, per charte.
export function JournalCodeBadge({ code, className, withLabel }: Props) {
  const { t } = useTranslation('accounting')
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md border border-border bg-muted px-2 py-0.5 text-xs font-semibold tabular-nums text-foreground',
        className,
      )}
      title={t(`journal_code.${code}`)}
    >
      <span>{code}</span>
      {withLabel ? (
        <span className="text-[10px] font-normal text-muted-foreground">
          {t(`journal_code.${code}`)}
        </span>
      ) : null}
    </span>
  )
}
